import React, { useState } from "react";
import {
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import CopyIconButton from "components/atoms/CopyIconButton";
import { TabProps } from "../../../../SourceModal.types";
import { getSourceDisplayName } from "../../../../SourceModal.config";
import BaseOverview from "./BaseOverview";

const AppOverview: React.FC<TabProps> = ({ source, tracker, language }) => {
    const [tokenAreaVisible, setTokenAreaVisible] = useState(true);
    const sourceCode = source?.source_type?.code;
    const displayName = getSourceDisplayName(
        sourceCode,
        source?.source_type?.name,
    );
    const alias = tracker?.tracker?.alias;

    const getDescription = () => {
        switch (sourceCode) {
            case "androidcapi":
                return "Integrate SignalSight with your Android application to track in-app events and conversions. Use the provided SDK to send events from your mobile app.";
            case "ioscapi":
                return "Integrate SignalSight with your iOS application to track in-app events and conversions. Use the provided SDK to send events from your mobile app.";
            default:
                return "Connect your mobile application to SignalSight for comprehensive event tracking and conversion optimization.";
        }
    };

    return (
        <BaseOverview language={language}>
            {alias && (
                <div>
                    <div className="bearer-token-area">
                        <span className="bearer-token-title">
                            {language?.tracker_detail?.overview
                                ?.bearer_token_title ??
                                "Authorization Token is (bearerAuth)"}
                            <a
                                href="javascript:;"
                                onClick={() =>
                                    setTokenAreaVisible(!tokenAreaVisible)
                                }
                            >
                                {!tokenAreaVisible ? (
                                    <VisibilityIcon />
                                ) : (
                                    <VisibilityOffIcon />
                                )}
                            </a>
                        </span>
                        <div className="bearer-token-blockquote">
                            {tokenAreaVisible ? (
                                <div className="blur-area">
                                    <span>{alias}</span>
                                </div>
                            ) : (
                                <span>{alias}</span>
                            )}
                            <CopyIconButton value={alias || ""} />
                        </div>
                    </div>
                    <p className="mt-3">{getDescription()}</p>
                    <div className="mt-3">
                        <h3 className="mb-2">Integration Steps:</h3>
                        <ul
                            style={{
                                paddingLeft: "1.5rem",
                                listStyleType: "disc",
                            }}
                        >
                            <li>Install the SignalSight SDK in your app</li>
                            <li>Initialize with your authorization token</li>
                            <li>Track events using the SDK methods</li>
                            <li>Verify integration in the dashboard</li>
                        </ul>
                    </div>
                </div>
            )}
        </BaseOverview>
    );
};

export default AppOverview;
